var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("page " + (_vm.inIframe?'in-iframe':'')),attrs:{"id":"app"}},[_c('div',{staticClass:"content-wrapper"},[_c('router-view',{staticClass:"content"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }